export function invariant(condition, message, Err) {
    if (Err === void 0) { Err = Error; }
    if (!condition) {
        throw new Err(message);
    }
}
//# sourceMappingURL=invariant.js.map


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/node_modules/@formatjs/intl-utils/lib/invariant.js
// module id = 521
// module chunks = 1